// extracted by mini-css-extract-plugin
export var borderRadius = "_6g-4";
export var large = "_6g-3";
export var logoContainer = "_6g-0";
export var nameLogo = "_6g-2";
export var small = "_6g-1";